<template>
    <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
            <p class="modal-card-title" style="margin: 0px;">Change Password</p>
        </header>
        <section class="modal-card-body change-password-modal">
            <b-message title="" type="is-danger" style="font-size: 14px; width: 350px;" v-if="error">
                Your password and confirmation password do not match.
            </b-message>

            <b-message title="" type="is-danger" style="font-size: 14px; width: 350px;" v-if="errorPattern">
                The password does not meet the password policy requirements: 6 characters minimum
            </b-message>

            <div class="row">
                <div class="col-xs-12">
                    <b-field label="Password">                     
                        <b-input
                            type="password" 
                            v-model="password" 
                            pattern=".{6,}" 
                            oninvalid="setCustomValidity('6 characters minimum')"
                            password-reveal 
                            required></b-input>
                    </b-field>
                </div>
            </div>
            <div class="row">
                <div class="col-xs-12">
                    <b-field label="Password confirm">
                        <b-input
                            type="password"
                            v-model="password_confirm"
                            pattern=".{6,}"
                            oninvalid="setCustomValidity('6 characters minimum')"
                            password-reveal
                            required></b-input>
                    </b-field>
                </div>
            </div>
        </section>
        <footer class="modal-card-foot" style="text-align: right;">
            <button class="button" type="button" @click="$parent.close()">Close</button>
            <button class="button is-primary" @click="emitEvent">Save</button>
        </footer>
    </div>
</template>

<script>
let password = "";
let password_confirm = "";
let error = false;
let errorPattern = false;

export default {
    name: 'ChangePassword',
    props:{},
    data(){
        return {
            password: password,
            password_confirm: password_confirm,
            error: error,
            errorPattern: errorPattern,
        }
    },
    components: {},
    methods:{
        emitEvent: function(){
            if(this.password.length < 6){
                this.errorPattern = true;
            }else{
                if(this.password != this.password_confirm){
                    this.error = true;
                }else{
                    this.$emit(
                        'changed_password', {
                            "password": this.password,
                            "password_confirmation": this.password_confirm
                        }
                    );
                    this.$parent.close()
                }
            }
        },
    },
    mounted: function () {
    }
}
</script>

<style scoped>
    .change-password-modal >>> .input{
        max-width: 100%;
        width: 350px;
    }
    .change-password-modal >>> .label{
        font-weight: 400;
        text-align: left;
        padding-left: 0px;
    }
    .change-password-modal >>> .field{
        margin-bottom: 20px;
    }
</style>
